import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const TenderCard = ({ tender, onViewDetails }) => {
  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case 'open':
        return 'bg-green-100 text-green-800';
      case 'closing soon':
        return 'bg-orange-100 text-orange-800';
      case 'closed':
        return 'bg-red-100 text-red-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };

  const formatDate = (dateString) => {
    return new Date(dateString)?.toLocaleDateString('en-IN', {
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    });
  };

  const getDaysRemaining = (deadline) => {
    const today = new Date();
    const deadlineDate = new Date(deadline);
    const diffTime = deadlineDate - today;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays;
  };

  const daysRemaining = getDaysRemaining(tender?.deadline);

  return (
    <div className="bg-card rounded-lg border border-border p-6 hover:shadow-card-shadow-lg transition-all duration-300">
      <div className="flex items-start justify-between mb-4">
        <div className="flex-1">
          <div className="flex items-center space-x-2 mb-2">
            <h3 className="font-semibold text-foreground">{tender?.title}</h3>
            <span className={`px-2 py-1 rounded-full text-xs font-medium ${getStatusColor(tender?.status)}`}>
              {tender?.status}
            </span>
          </div>
          <p className="text-sm text-muted-foreground mb-3">{tender?.description}</p>
          <div className="flex items-center space-x-4 text-sm text-muted-foreground">
            <span className="flex items-center space-x-1">
              <Icon name="Calendar" size={14} />
              <span>Published: {formatDate(tender?.publishedDate)}</span>
            </span>
            <span className="flex items-center space-x-1">
              <Icon name="Clock" size={14} />
              <span>Deadline: {formatDate(tender?.deadline)}</span>
            </span>
          </div>
        </div>
      </div>
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-4">
          <span className="text-sm text-muted-foreground">
            Tender ID: {tender?.tenderId}
          </span>
          {daysRemaining > 0 && daysRemaining <= 7 && (
            <span className="flex items-center space-x-1 text-orange-600">
              <Icon name="AlertTriangle" size={14} />
              <span className="text-sm font-medium">{daysRemaining} days left</span>
            </span>
          )}
        </div>
        <div className="flex items-center space-x-2">
          {tender.filename && (
            <a
              href={`http://localhost:5000/uploads/${tender.filename}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <Button
                variant="outline"
                size="sm"
                iconName="Download"
                iconPosition="left"
              >
                Download Document
              </Button>
            </a>
          )}
          <Button
            variant="default"
            size="sm"
            iconName="ExternalLink"
            iconPosition="right"
            onClick={() => onViewDetails(tender)}
          >
            View Details
          </Button>
        </div>
      </div>
    </div>
  );
};

export default TenderCard;